import { loginWithSsoTokens, useAppDispatch } from "@template/state";
import { ROUTES } from "@template/types";
import { FullPageStatus, showToast } from "@template/ui";
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getErrorMessage } from "../../lib/error-message";

export function SsoCallbackPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const accessToken = searchParams.get("accessToken");
    const refreshToken = searchParams.get("refreshToken");

    if (!accessToken || !refreshToken) {
      showToast("Microsoft sign-in did not return valid tokens", "error");
      navigate(ROUTES.login, { replace: true });
      return;
    }

    dispatch(loginWithSsoTokens({ accessToken, refreshToken }))
      .unwrap()
      .then(() => navigate(ROUTES.home, { replace: true }))
      .catch((err: unknown) => {
        showToast(getErrorMessage(err, "Microsoft sign-in failed"), "error");
        navigate(ROUTES.login, { replace: true });
      });
  }, [dispatch, navigate, searchParams]);

  return <FullPageStatus variant="loading" title="Signing you in..." />;
}
